import { List } from 'antd'
import styled from 'styled-components'

EmptyContainer = styled.div"""
  display: flex;
  flex-direction: column;
  height: 67vh;
  & > div:first-child {
    flex-grow: 1;
  }
  & > div:last-child {
    flex-grow: 1;
  }
"""
PageContainer = styled.div"""
  display: flex;
  flex-direction: column;
  height: 100vh;
"""
StyledList = styled(List)"""
  background: var(--background);
  margin: 20px;
  padding: 40px;
  border-radius: 10px;
  padding-bottom: 10px;
  flex-grow: 2;
  overflow: auto;
"""
StyledFooter = styled.div"""
  padding: 12px 12px;
  text-align: right;
  background: var(--background);
  width: 100%;
  border-top: 1px solid var(--borderColor);
"""

export {
  EmptyContainer,
  PageContainer,
  StyledList,
  StyledFooter
}